import { render, staticRenderFns } from "./sublibrary.vue?vue&type=template&id=2d235bf7&scoped=true&"
import script from "./sublibrary.vue?vue&type=script&lang=js&"
export * from "./sublibrary.vue?vue&type=script&lang=js&"
import style0 from "./sublibrary.vue?vue&type=style&index=0&id=2d235bf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d235bf7",
  null
  
)

export default component.exports